import { Pipe, PipeTransform } from "@angular/core";
import { IObservationDefinitionComponent } from "@comunicare/comunicare-interfaces";

@Pipe({
  name: "findObsDefComponentsByLoinc",
})
export class FindObsDefComponentsByLoincPipe implements PipeTransform {
  transform(components: IObservationDefinitionComponent[], loinc: string): IObservationDefinitionComponent {
    return components.find((component) => component.loinc === loinc);
  }
}
